export const SALES_FEES_FORM_PREFIX = 'salesFeesForm';

export const SALES_FEES_FIELDS_NAMES = {
  TOTAL_FEES: `${SALES_FEES_FORM_PREFIX}.salesFees`,
  SALES_DOCOMENT_FEES: `${SALES_FEES_FORM_PREFIX}.salesDocumentFees`,
  TITLE_REGISTRATION_LICENSE: `${SALES_FEES_FORM_PREFIX}.titleRegistrationLicense`,
};
